var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndpageEllipseLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 198,
    viewBox: "0 0 186 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.832 204.778C166.369 218.787 143.583 227.466 119.733 229.956C95.8824 232.446 71.7953 228.66 49.8587 218.974C27.9222 209.287 8.89786 194.036 -5.32884 174.732C-19.5555 155.428 -28.4906 132.741 -31.2486 108.92C-34.0065 85.0993 -30.4916 60.9712 -21.0521 38.9271C-11.6127 16.8831 3.42362 -2.31147 22.5665 -16.7543C41.7093 -31.1971 64.2941 -40.3866 88.0826 -43.4122C111.871 -46.4377 136.037 -43.1943 158.186 -34.0032L133.879 24.5707C121.938 19.6154 108.909 17.8667 96.0839 19.4979C83.2585 21.1291 71.0821 26.0836 60.7614 33.8703C50.4407 41.657 42.3341 52.0056 37.2448 63.8905C32.1556 75.7753 30.2606 88.7838 31.7475 101.627C33.2344 114.47 38.0517 126.701 45.7219 137.108C53.3921 147.516 63.6489 155.738 75.4758 160.961C87.3027 166.183 100.289 168.225 113.148 166.882C126.007 165.54 138.291 160.86 148.784 153.308L185.832 204.778Z",
    fill: "url(#paint0_linear_2718_4670)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2718_4670",
    x1: 184.539,
    y1: -19.5089,
    x2: 26.3497,
    y2: 205.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C38CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E297DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpageEllipseLeft);
export default __webpack_public_path__ + "static/media/EndpageEllipseLeft.b6b1c9c721b1321d4c0285a7b51a9aa1.svg";
export { ForwardRef as ReactComponent };